// Helpers for Markdown text (AI / LLM output). Render it with
// `commonComponents/MarkdownContent.jsx`, which applies these for you.

// A bare http(s) URL, without trailing ")" or "." picked up from the sentence.
const URL_REGEX = /(https?:\/\/[^\s)]+[^\s).])/g;

/**
 * react-markdown (without the remark-gfm plugin, which this project doesn't
 * depend on) renders a bare URL as inert text. Wraps every bare URL that isn't
 * already inside Markdown link syntax as `[url](url)`, so it renders as a link.
 *
 * @param {string} text - Markdown content that may contain bare URLs
 * @returns {string} Same text with bare URLs converted to Markdown links
 */
export function linkifyPlainUrls(text) {
  if (!text) return text;
  return text.replace(URL_REGEX, (match, _p1, offset, fullString) => {
    const precedingChars = fullString.slice(Math.max(0, offset - 2), offset);
    // Already the target of a markdown link — e.g. "...text](https://...)" — leave as-is.
    if (precedingChars === "](") return match;
    return `[${match}](${match})`;
  });
}
